export enum FileOrderColumnEnum {
  Title = 0,
  Size = 4,
  ModifiedAt = 3,
}
